export enum A11yState {
  AriaChecked = 'aria-checked',
  AriaSelected = 'aria-selected',
  AriaDisabled = 'aria-disabled',
  AriaExpanded = 'aria-expanded',
  AriaInvalid = 'aria-invalid',
  AriaHidden = 'aria-hidden',
  AriaPressed = 'aria-pressed',
  AriaCurrent = 'aria-current',
  AriaBusy = 'aria-busy',
  AriaRequired = 'aria-required',
  AriaReadonly = 'aria-readonly',
  AriaValueNow = 'aria-valuenow',
  AriaValueMin = 'aria-valuemin',
  AriaValueMax = 'aria-valuemax',
  AriaSort = 'aria-sort',
}